// extracted by mini-css-extract-plugin
export default {"modal":"IItR005isdx3RQiS7DtD","rotating":"kS2QKGxTZDoMDOXUdpSI"};